import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../_service/auth.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  router = inject(Router);

  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  message: any;
  private subscription: Subscription | undefined;
  showPassword: boolean = false; // Toggle password visibility
  isLoading: boolean = false; // Loading state

  ngOnInit() {
    this.subscription = this.authService.isAuthenticated$
      .subscribe(isAuthenticated => {
        if (isAuthenticated) {
          this.router.navigate(['/home']);
        }
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true; // Start loading
      this.message = null; // Clear previous messages

      this.authService.login(this.loginForm.value)
        .subscribe({
          next: (user) => {
            this.isLoading = false; // Stop loading
            if (user?.error) {
              this.message = user?.error?.message;
              Swal.fire('Error', user?.error?.message, 'error');
            } else {
              Swal.fire({
                title: 'Success!',
                text: 'Login successful',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                confirmButtonColor: '#00a859'
              }).then(() => {
                this.router.navigate(['/home']);
              });
            }
          },
          error: (error) => {
            this.isLoading = false; // Stop loading
            console.error('Login error:', error);
            this.message = error?.message || 'An error occurred';
            Swal.fire('Error', error?.message || 'An error occurred', 'error');
          }
        });
    } else {
      Swal.fire('Error', 'Please fill in all required fields correctly', 'error');
    }
  }

  // Toggle Password Visibility
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
}
